// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"443":"about","573":"party"}[chunkId] || chunkId) + "." + {"139":"68b8c60b","443":"1f90af40","573":"fe122582"}[chunkId] + ".css";
};